export const containerStyles = `
  w-full flex items-start gap-3
  p-4 border rounded-xl
`

export const cardContainerStyles = `
  flex flex-col gap-3 w-full overflow-hidden
`
export const cardDetailsContainerStyles = `
  flex flex-col gap-1 w-full overflow-hidden
`
export const cardTitleStyles = `text-sm-semibold`

export const cardDescriptionStyles = `text-sm-regular`

export const cardActionContainerStyles = 'flex items-center gap-[12px]'

export const cardActionButtonStyles = 'bg-transparent'

export const defaultAlertIconContainerStyles = 'p-[10px] rounded-[8px] border'
